import React from 'react'
import UrgencyLabel from 'components/Luxkit/Label/UrgencyLabel'
import { groupBy } from 'lib/array/arrayUtils'
import PromotionLabel from 'components/Luxkit/Label/PromotionLabel'
import LineAwardIcon from 'components/Luxkit/Icons/line/LineAwardIcon'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'
import { getUrgencyTagVariant } from 'lib/tours/tourUtils'
import TourDiscountLabel from 'components/Tours/TourDiscountLabel'

const positionTagsMap = new Map([
  ['bestseller', {
    position: 'start',
    tag: <PromotionLabel key="bestseller" variant="default" icon={<LineAwardIcon />} data-testid="UrgencyLabel">Bestseller</PromotionLabel>,
  }],
  ['sale', {
    position: 'end',
    tag: <TourDiscountLabel key="sale" />,
  }],
  ['departuresale', {
    position: 'end',
    tag: <TourDiscountLabel key="departuresale" saleOnDepartures />,
  }],
])

interface Props {
  className?: string;
  tags: Array<string>;
}

function TourV2UrgencyTags(props: Props) {
  const tagsByPosition = groupBy(props.tags, (tag) => {
    if (positionTagsMap.has(tag.toLowerCase())) {
      return positionTagsMap.get(tag.toLowerCase()).position
    } else {
      return 'auto'
    }
  })
  if (!tagsByPosition.has('start') && !tagsByPosition.has('auto') && !tagsByPosition.has('end')) {
    return null
  }
  return <LabelGroup className={props.className}>
    {tagsByPosition.has('start') && tagsByPosition.get('start').map((tag) => positionTagsMap.get(tag.toLowerCase()).tag)}
    {tagsByPosition.has('auto') && tagsByPosition.get('auto').map((tag) => <UrgencyLabel key={tag} variant={getUrgencyTagVariant(tag)}>{tag}</UrgencyLabel>)}
    {tagsByPosition.has('end') && tagsByPosition.get('end').map((tag) => positionTagsMap.get(tag.toLowerCase()).tag)}
  </LabelGroup>
}

export default TourV2UrgencyTags
